import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@env/environment';

import { SyndicRoutingModule } from './syndic-routing.module';
import { SyndicAddComponent } from './syndic/syndic-add/syndic-add.component';
import { SyndicListComponent } from './syndic/syndic-list/syndic-list.component';
import { SyndicShowComponent } from './syndic/syndic-show/syndic-show.component';
import { MandateAddComponent } from './mandate/mandate-add/mandate-add.component';
import { MandateListComponent } from './mandate/mandate-list/mandate-list.component';
import { MandateShowComponent } from './mandate/mandate-show/mandate-show.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from '@theme/shared/components';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { ToastyModule } from 'ng2-toasty';
import { NgbCarouselModule, NgbDatepickerModule, NgbDropdownModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@theme/shared/shared.module';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AgmCoreModule } from '@agm/core';
import { ProprietaireModule } from '@agence/proprietaire/proprietaire.module';
import { InfrastructureAddComponent } from './infrastructure/infrastructure-add/infrastructure-add.component';
import { InfrastructureListComponent } from './infrastructure/infrastructure-list/infrastructure-list.component';
import { InfrastructureShowComponent } from './infrastructure/infrastructure-show/infrastructure-show.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ExtraModule } from '@agence/extra/extra.module';
import { PrestataireModule } from '@agence/prestataire/prestataire.module';
import { ChantierModule } from '@agence/chantier/chantier.module';
import { FundsApealsListComponent } from './funds-apeals/funds-apeals-list/funds-apeals-list.component';
import { FundsApealsShowComponent } from './funds-apeals/funds-apeals-show/funds-apeals-show.component';
import { FundsNoticeListComponent } from './funds-notice/funds-notice-list/funds-notice-list.component';
import { FundsNoticeShowComponent } from './funds-notice/funds-notice-show/funds-notice-show.component';
import { FundsPaymentListComponent } from './funds-payment/funds-payment-list/funds-payment-list.component';
import { FundsPaymentShowComponent } from './funds-payment/funds-payment-show/funds-payment-show.component';
import { FundsPaymentAddComponent } from './funds-payment/funds-payment-add/funds-payment-add.component';
import { BudgetModule } from '@agence/budget/budget.module';
import { OwnerCoAddComponent } from './owner-co/owner-co-add/owner-co-add.component';
import { OwnerCoListComponent } from './owner-co/owner-co-list/owner-co-list.component';
import { OwnerCoShowComponent } from './owner-co/owner-co-show/owner-co-show.component';
import { ChargeExceptionnelleAddComponent } from './charge-exceptionnelle/charge-exceptionnelle-add/charge-exceptionnelle-add.component';
import { ChargeExceptionnelleListComponent } from './charge-exceptionnelle/charge-exceptionnelle-list/charge-exceptionnelle-list.component';

// Phase 2 - Finances
import { PenaltyAddComponent } from './penalty/penalty-add/penalty-add.component';
import { PenaltyListComponent } from './penalty/penalty-list/penalty-list.component';
import { HonoraireAddComponent } from './honoraire/honoraire-add/honoraire-add.component';
import { HonoraireListComponent } from './honoraire/honoraire-list/honoraire-list.component';
import { CompteAddComponent } from './compte/compte-add/compte-add.component';
import { CompteListComponent } from './compte/compte-list/compte-list.component';
import { TransactionSyndicAddComponent } from './transaction-syndic/transaction-syndic-add/transaction-syndic-add.component';
import { TransactionSyndicListComponent } from './transaction-syndic/transaction-syndic-list/transaction-syndic-list.component';
import { FactureCoproprietaireAddComponent } from './facture-coproprietaire/facture-coproprietaire-add/facture-coproprietaire-add.component';
import { FactureCoproprietaireListComponent } from './facture-coproprietaire/facture-coproprietaire-list/facture-coproprietaire-list.component';
import { LigneBudgetAddComponent } from './ligne-budget/ligne-budget-add/ligne-budget-add.component';
import { LigneBudgetListComponent } from './ligne-budget/ligne-budget-list/ligne-budget-list.component';


@NgModule({
  declarations: [
    SyndicAddComponent,
    SyndicListComponent,
    SyndicShowComponent,
    MandateAddComponent,
    MandateListComponent,
    MandateShowComponent,
    InfrastructureAddComponent,
    InfrastructureListComponent,
    InfrastructureShowComponent,
    FundsApealsListComponent,
    FundsApealsShowComponent,
    FundsNoticeListComponent,
    FundsNoticeShowComponent,
    FundsPaymentListComponent,
    FundsPaymentShowComponent,
    FundsPaymentAddComponent,
    OwnerCoAddComponent,
    OwnerCoListComponent,
    OwnerCoShowComponent,
    ChargeExceptionnelleAddComponent,
    ChargeExceptionnelleListComponent,
    // Phase 2 - Finances
    PenaltyAddComponent,
    PenaltyListComponent,
    HonoraireAddComponent,
    HonoraireListComponent,
    CompteAddComponent,
    CompteListComponent,
    TransactionSyndicAddComponent,
    TransactionSyndicListComponent,
    FactureCoproprietaireAddComponent,
    FactureCoproprietaireListComponent,
    LigneBudgetAddComponent,
    LigneBudgetListComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,    
    SharedModule,
    ExtraModule,
    ModalModule,
    SyndicRoutingModule,
    TextMaskModule,
    FormsModule,
    FileUploadModule,
    ToastyModule,
    NgbTabsetModule,
    NgbCarouselModule,
    DataTablesModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    BsDatepickerModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    NgxDocViewerModule,
    ProprietaireModule,
    PrestataireModule,
    ChantierModule,
    BudgetModule,
    AgmCoreModule.forRoot({ apiKey: environment.googleMapsApiKey }),
  ],
  exports: [
    SyndicAddComponent,
    MandateAddComponent,
    MandateShowComponent,
    InfrastructureAddComponent,
    InfrastructureShowComponent,
    InfrastructureListComponent,
    OwnerCoAddComponent,
    OwnerCoListComponent,
    OwnerCoShowComponent,
    ChargeExceptionnelleAddComponent,
    ChargeExceptionnelleListComponent,
    // Phase 2 - Finances
    PenaltyAddComponent,
    PenaltyListComponent,
    HonoraireAddComponent,
    HonoraireListComponent,
    CompteAddComponent,
    CompteListComponent,
    TransactionSyndicAddComponent,
    TransactionSyndicListComponent,
    FactureCoproprietaireAddComponent,
    FactureCoproprietaireListComponent,
    LigneBudgetAddComponent,
    LigneBudgetListComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
})
export class SyndicModule { }
